<div class="d-flex" #panel
     [class.justify-content-between]="!(searchCakes.criteriaIsEmpty$ | async)"
     [class.justify-content-end]="(searchCakes.criteriaIsEmpty$ | async)">
  <div class="filter-tags-container"
       *ngIf="!(searchCakes.criteriaIsEmpty$ | async)">
    <button class="btn btn-pink btn-slim btn-filter-panel"
            (click)="resetFilters()">
      <div class="d-flex">
        <div class="me-2"
             [translate]="'orderProcess.cakesOverview.filterTags.clearAll'">
        </div>

        <i class="icon-close font-xs"></i>
      </div>
    </button>

    <ng-container *ngFor="let allergen of model.allergens">
      <button class="btn btn-gray btn-slim btn-filter-panel"
              *ngIf="allergen.checked"
              (click)="allergen.checked = false; onModelChange()">
        <div class="d-flex">
          <div class="me-2">
            {{allergen.label || allergen?.ref?.name}}
          </div>

          <i class="icon-close font-xs"></i>
        </div>
      </button>
    </ng-container>

    <ng-container *ngFor="let group of model.productGroups">
      <button class="btn btn-gray btn-slim btn-filter-panel"
              *ngIf="group.checked"
              (click)="group.checked = false; onModelChange()">
        <div class="d-flex">
          <div class="me-2">
            {{group.ref.name}}
          </div>
          <i class="icon-close font-xs"></i>
        </div>
      </button>
    </ng-container>

    <button class="btn btn-gray btn-slim btn-filter-panel"
            *ngIf="model.hasMotive"
            (click)="model.hasMotive = false; onModelChange()">
      <div class="d-flex">
        <div class="me-2"
             [translate]="'orderProcess.cakesOverview.filterTags.hasMotive'">
        </div>
        <i class="icon-close font-xs"></i>
      </div>
    </button>

    <button class="btn btn-gray btn-slim btn-filter-panel"
            *ngIf="model.postNumber"
            (click)="model.postNumber = ''; onModelChange()">
      <div class="d-flex">
        <div class="me-2">
          <span
            [translate]="'orderProcess.cakesOverview.filterTags.deliveryToPrefix'">Delivery to</span>&nbsp;{{model.postNumber}}
        </div>
        <i class="icon-close font-xs"></i>
      </div>
    </button>
  </div>

  <ng-content
    *ngIf="!(searchCakes.criteriaIsEmpty$ | async) || isStick" select=".right-side"></ng-content>
</div>
